<template>
  <div class="ssoConfig">
    <el-form
      class="configForm"
      :rules="ruleForm"
      ref="ruleForm"
      label-position="top"
      label-width="80px"
      :model="formLabelAlign">
      <p class="oneTitle">SSO SAML</p>
      <p class="twoTitle">Okta and OneLogin available for Enterprise TVU subscribers.</p>
      <el-divider></el-divider>
      <el-form-item
        label="Corporation name"
        prop="name">
        <el-input
          type='text'
          v-model="formLabelAlign.name"
          maxlength="128"></el-input>
      </el-form-item>
      <el-form-item
        label="Contact email address"
        prop="email">
        <el-input
          v-model="formLabelAlign.email"
          maxlength="50"></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <p class="twoTitle three">What IdP do you use?</p>
      <p class="twoTitle four">Because each IdP requires different information for setup,we’ll first need you to tell us more information about what SAML IdP you are using. Then your users can enforce SSO.</p>
      <el-form-item
        label="Select your SAML IdP"
        prop="samlIdP">
        <el-radio-group v-model="formLabelAlign.samlIdP">
          <!-- <el-radio label="onelogin"></el-radio>
					<br> -->
          <el-radio label="okta">OKTA</el-radio>
          <br>
          <el-radio
            style='margin-top: 15px;'
            label="OneLogin">OneLogin</el-radio>
          <br>
          <el-radio
            style='margin-top: 15px;'
            label="Microsoft">Microsoft Azure</el-radio>
        </el-radio-group>
      </el-form-item>
      <div style='position: relative'>
        <el-button
          class='add-domain'
          plain
          @click='addDomain'
          type='success'>+ Add domain</el-button>
        <el-form-item
          label="Please enter your company’s domain here.">
          <span class='domain-icon'>*</span>
          <el-input
            class='domain-input'
            v-for='(item, index) in domainsList'
            :key='index'
            v-model='domainsList[index]'
            maxlength="128">
            <i
              v-if='index != 0'
              @click='deleteDomain(index)'
              slot="suffix"
              class="el-icon-circle-close"></i>
          </el-input>
        </el-form-item>
      </div>
      <p class="twoTitle six">{{providerTitle}}</p>
      <p class="twoTitle four">To configure SSO for TVU, please set up TVU service as an application within your IdP. With {{providerTitle}} this is easy! Search for the TVU application and our information will pre-fill.</p>
      <p class="twoTitle four">Once you’ve set up the application, please send us the following information and we’ll get things hooked up on our side:</p>
      <p class="twoTitle four">- {{providerLabel}} </p>
      <p class="twoTitle five">- {{providerSubLabel}}</p>
      <p class="twoTitle five">- SAML Certificate{{formLabelAlign.samlIdP == 'Microsoft' ? '(Base64)' : ''}}</p>
      <el-form-item
        :label="providerLabel"
        prop="ssoUrl">
        <el-input
          type='text'
          v-model="formLabelAlign.ssoUrl"
          maxlength="128"></el-input>
      </el-form-item>
      <el-form-item
        :label="providerSubLabel"
        prop="entityID">
        <el-input
          type='text'
          v-model="formLabelAlign.entityID"
          maxlength="128"></el-input>
      </el-form-item>
      <el-form-item
        :label="formLabelAlign.samlIdP == 'Microsoft' ? 'SAML Certificate(Base64)' : 'SAML Certificate'"
        prop="certificate">
        <el-input
          type="textarea"
          v-model="formLabelAlign.certificate"></el-input>
      </el-form-item>
      <div class="operate">
        <el-button
          class="confirmBtn cursor"
          v-repeat-click="{event:nextOperation}">Next</el-button>
        <span
          class="back cursor"
          @click="routerPush('/signInsso')">Back</span>
      </div>
    </el-form>

  </div>
</template>
<script>
export default {
  name: 'Success',
  data () {
    return {
      formLabelAlign: {
        name: '',
        email: '',
        samlIdP: 'okta',
        domains: '',
        ssoUrl: '',
        entityID: '',
        certificate: ''
      },
      domainsList: ['']
    }
  },
  computed: {
    providerTitle () {
      return this.getProviderLabel('title')
    },
    providerLabel () {
      return this.getProviderLabel('label')
    },
    providerSubLabel () {
      return this.getProviderLabel('subLabel')
    },
    ruleForm () {
      return {
        name: [{ required: true, message: 'Please enter Corporation name', trigger: 'blur' }],
        email: [{ required: true, message: 'Please enter Contact email address', trigger: 'blur' },
          { type: 'email', message: 'Contact email address fromat error', trigger: 'blur' }],
        samlIdP: [{ required: true, message: 'Please enter SAML IdP', trigger: 'change' }],
        // domains: [{ required: true, message: 'Please enter company’s domain', trigger: 'blur' }],
        ssoUrl: [{ required: true, message: 'Please enter ' + this.providerLabel, trigger: 'blur' }],
        entityID: [{ required: true, message: 'Please enter ' + this.providerSubLabel, trigger: 'blur' }],
        certificate: [{ required: true, message: this.formLabelAlign.samlIdP == 'Microsoft' ? 'Please enter SAML Certificate(Base64)' : 'Please enter SAML Certificate', trigger: 'blur' }]
      }
    }
  },
  methods: {
    getProviderLabel (type) {
      const providerLabels = {
        okta: {
          title: 'Okta',
          label: 'SAML Okta URL',
          subLabel: 'SAML IDP EntityID'
        },
        OneLogin: {
          title: 'OneLogin',
          label: 'SAML Single Sign-On URL (SAML 2.0 Endpoint)',
          subLabel: 'SAML Issuer URL'
        },
        Microsoft: {
          title: 'Microsoft Azure',
          label: 'SAML Login URL',
          subLabel: 'SAML Azure AD Identifier'
        }
      }

      const currentProvider = providerLabels[this.formLabelAlign.samlIdP] || {}
      return currentProvider[type] || ''
    },
    addDomain () {
      this.domainsList.push('')
    },
    deleteDomain (index) {
      this.domainsList.splice(index, 1)
    },
    nextOperation () {
      const domainsList = this.domainsList.filter(item => {
        return item && item.trim()
      })
      if (domainsList && domainsList.length < 1) {
        return this.$message.error('Please enter company’s domain')
      }
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return
        }
        this.axios.post('/userGroup/user-group/login/saveSSOConfig',
          {
            companyName: this.formLabelAlign.name.trim(),
            email: this.formLabelAlign.email.trim(),
            platform: this.formLabelAlign.samlIdP.trim(),
            ssoUrl: this.formLabelAlign.ssoUrl.trim(),
            entityId: this.formLabelAlign.entityID.trim(),
            companyDomain: domainsList.join(','),
            certificate: this.formLabelAlign.certificate.trim()
          }
        ).then((res) => {
          // if(res.data.errorCode == '0x0'){
          // 跳转code页面
          if (res.data.errorCode == '0x0') {
            // const data = res.data.result
            this.$store.commit('changeContactEmail', this.formLabelAlign.email)
            this.$router.push('/waitingPage')
          }
        }).catch()
      })
    },
    routerPush (path) {
      // ga('send', 'event', 'newUserService-ssoConfig-back', 'click')
      gtag('event', 'newUserService-ssoConfig-back')
      this.$store.commit('changeShowConfig', false)
      this.$router.push(path)
    }
  },
  beforeDestroy () {

  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('changeShowConfig', true)
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
      vm.$store.commit('changeShowConfig', false)
    })
  }
}
</script>
<style scoped>
.add-domain {
  position: absolute;
  top: 55px;
  right: 30px;
  z-index: 9;
}

.domain-input {
  margin-bottom: 10px;
}
/deep/.el-input__suffix {
  right: 0;
  top: 5px;
  cursor: pointer;
  font-size: 16px;
  right: 180px;
}

.domain-icon {
  color: red;
  position: absolute;
  left: -10px;
  font-weight: bold;
  top: -5px;
}
</style>
